import { render, staticRenderFns } from "./UploadFilesTable.vue?vue&type=template&id=2718928c&scoped=true&"
import script from "./UploadFilesTable.vue?vue&type=script&lang=js&"
export * from "./UploadFilesTable.vue?vue&type=script&lang=js&"
import style0 from "./UploadFilesTable.css?vue&type=style&index=0&id=2718928c&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2718928c",
  null
  
)

export default component.exports